import { render } from "./BusinessName.vue?vue&type=template&id=32cf4d54"
import script from "./BusinessName.vue?vue&type=script&lang=js"
export * from "./BusinessName.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__